import store from "../store";
import { can } from "../plugins/permissions";
import { ensureSession, ensureFreshSession } from "@/utils/session";
import {
  isAttendanceExperienceRoute,
  resolveAttendanceExperienceRoute,
} from "@/utils/multiAttendance";

export default async (to, from, next) => {
  //settings
  document.title = process.env.VUE_APP_DOCUMENT_TITLE;

  if (to.name !== from.name) window.scrollTo(0, 0);

  // handle auth state
  const requiresAuth = to.meta.requiresAuth || false;
  const preventAuth = to.meta.preventAuth || false;

  // O F5 reidrata a store a partir do localStorage, então tudo que o admin
  // mudou com a sessão aberta (permissões, vínculo, quantidade de atendimentos
  // simultâneos) chega aqui defasado e a navegação inicial seria decidida com o
  // dado velho. Esperar a sessão custa o tempo de um `GET /auth` que o App faria
  // de qualquer forma — a tela só é pintada depois dele.
  //
  // Nas telas de atendimento a sessão do carregamento da página também não
  // basta: o limite muda com a sessão aberta, e sem F5 a navegação continuaria
  // caindo na tela antiga a cada visita. Por isso essas rotas exigem um dado
  // recém-buscado. Ver ADR-008.
  if (store.getters.authenticated) {
    try {
      await (isAttendanceExperienceRoute(to)
        ? ensureFreshSession()
        : ensureSession());
    } catch {
      // Sessão inválida: o interceptor da API cuida do signOut e do /auth. As
      // checagens abaixo seguem com o que restou na store.
    }
  }

  const authenticated = store.getters.authenticated;
  const authorized = to.meta.requiresPermission
    ? can(to.meta.requiresPermission)
    : true;

  // if the user has not authenticated and tries access private page
  if (requiresAuth && !authenticated) return next("/auth");

  if (
    authenticated &&
    store.getters.audienceRole !== "admin" &&
    store.getters.attendanceRole !== "admin" &&
    store.getters.attendanceRole !== "moderator" &&
    !store.getters.linkedAccess &&
    to.name !== "UserNotLinked"
  ) {
    return next("/user-not-linked");
  }

  // if the user has authenticated and tries access prevent authenticated page or module is not authorized
  if ((preventAuth && authenticated) || !authorized) return next("/");

  // Piloto de multiatendimento: a tela de atendimento certa depende do limite
  // do usuário, que o admin muda a qualquer momento. Ver ADR-008.
  if (authenticated) {
    const attendanceRoute = resolveAttendanceExperienceRoute(to);

    if (attendanceRoute) return next(attendanceRoute);
  }

  // else... next
  next();
};
